import styled from 'styled-components';

export const NameContainer = styled.div`
  display: flex;
`;
